export const SEO_API_URL = (import.meta.env.VITE_SEO_API_URL || "https://api.chatdna.co").replace(/\/$/, "");
export const APP_LOGIN_URL = import.meta.env.VITE_APP_LOGIN_URL || "https://app.emailsunsubscriber.com/login";
export const SITE_URL = "https://www.emailsunsubscriber.com";
